export default __webpack_public_path__ + "assets/icons/submitHistoryIcon.764d6291.svg";